module.exports = __webpack_public_path__ + "static/media/29ADMSPC24.1314fad9.jpg";